import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const CrediDebitNoteBasicInfoComponent = ({
    selectCrediDebitNotes, handleInnerFormChange, referenceTypeList, documentTypeList, grnsList, stockTransfersList, ordersList,
    supplierNameList, storeNameList
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Note Number"
                            name="NoteNumber"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'NoteNumber',
                                )
                            }}
                            type="text"
                            value={selectCrediDebitNotes?.NoteNumber}
                        />
                        <InputContainer
                            label="Reference Type"
                            labelField="Text"
                            list={referenceTypeList}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ReferenceTypeId'
                                )
                            }}
                            optionName='Choose Reference Type'
                            type="select"
                            value={selectCrediDebitNotes?.ReferenceTypeId}
                            valueField="Value"
                        />
                        <InputContainer
                            label="Document Type"
                            labelField="Text"
                            list={documentTypeList}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'DocumentTypeId'
                                )
                            }}
                            optionName='Choose Document Type'
                            type="select"
                            value={selectCrediDebitNotes?.DocumentTypeId}
                            valueField="Value"
                        />

                        {selectCrediDebitNotes?.DocumentTypeId === 10 && (
                            <InputContainer
                                label="GRN"
                                labelField="GRNNumber"
                                list={grnsList}
                                onValueChange={(event: any, newValue: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'GRNId'
                                    );
                                }}
                                optionName='Choose GRN Number'
                                type="select"
                                value={selectCrediDebitNotes?.GRNId}
                                valueField="Id"
                            />
                        )}
                        {selectCrediDebitNotes?.DocumentTypeId === 20 && (
                            <InputContainer
                                label="Stock Transfer"
                                labelField="NoteNumber"
                                list={stockTransfersList}
                                onValueChange={(event: any, newValue: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'StockTransferIndentId'
                                    );
                                }}
                                optionName='Choose Stock Transfer Number'
                                type="select"
                                value={selectCrediDebitNotes?.StockTransferIndentId}
                                valueField="Id"
                            />
                        )}
                        {/* {selectCrediDebitNotes?.DocumentTypeId === 30 && (
                            <InputContainer
                                label="Order Number"
                                labelField="OrderNumber"
                                list={ordersList}
                                onValueChange={(event: any, newValue: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'OrderStatusId'
                                    );
                                }}
                                optionName='Choose Order Number'
                                type="select"
                                value={selectCrediDebitNotes?.OrderStatusId}
                                valueField="Id"
                            />
                        )} */}
                        <InputContainer
                            // isDisabled
                            label="Reference"
                            labelField="ReferenceId"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ReferenceId'
                                );
                            }}
                            type="number"
                            value={selectCrediDebitNotes?.ReferenceId}
                        />
                        <InputContainer
                            label="Reference Date"
                            name="ReferenceDate"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ReferenceDate'
                                )
                            }}
                            type="date"
                            value={selectCrediDebitNotes?.ReferenceDate}
                        />
                        <InputContainer
                            label="Invoice Number"
                            labelField="InvoiceNumber"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'InvoiceNumber'
                                );
                            }}
                            type="text"
                            value={selectCrediDebitNotes?.InvoiceNumber}
                        />
                        <InputContainer
                            label="Invoice Date"
                            name="InvoiceDate"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'InvoiceDate'
                                )
                            }}
                            type="date"
                            value={selectCrediDebitNotes?.InvoiceDate}
                        />
                        <InputContainer
                            label="Supplier Name"
                            labelField="Name"
                            list={supplierNameList}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'SupplierId'
                                );
                            }}
                            optionName='Choose Supplier Name'
                            type="select"
                            value={selectCrediDebitNotes?.SupplierId}
                            valueField="Id"
                        />
                        <InputContainer
                            label="Store Name"
                            labelField="StoreInfo.StoreName"
                            list={storeNameList}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'StoreId'
                                );
                            }}
                            optionName='Choose Store Name'
                            type="select"
                            value={selectCrediDebitNotes?.StoreId}
                            valueField="StoreInfo.Id"
                        />
                        <InputContainer
                            label="Amount"
                            name="Amount"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Amount'
                                );
                            }}
                            type="number"
                            value={selectCrediDebitNotes?.Amount}
                        />
                        <InputContainer
                            label="Remarks"
                            labelField="Remarks"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Remarks'
                                );
                            }}
                            type="text"
                            value={selectCrediDebitNotes?.Remarks}
                        />
                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />
        </>
    )
}
export default CrediDebitNoteBasicInfoComponent;
